module.exports = __webpack_public_path__ + "static/media/homewise-for-partners.ccd3d07e.png";